export default __webpack_public_path__ + "static/media/YAS0510.34I-27776_-17201_0.b844091b.jpg";